import { preferencesTypes } from '../../../../shared/constants/preference-types.constant';

export class DefaultMatrixConfiguration {
  prop: string;
  rows: string;
  columns: string;
  title?: string;
  type?: string = 'checkboxMatrix';
  rowIdProp?: string = 'id';
  columnIdProp?: string = 'id';
  boldTitles = true;
  errorMessage?: string = 'Data Error';
  radioConfig?: DefaultMatrixRadioConfiguration;
  readOnly?: any;
  isHidden?: boolean;
  showGrid?: any;
  /* istanbul ignore next */
  constructor(options = {}) {
    Object.assign(this, options);
  }
}

export class DefaultMatrixRadioConfiguration {
  prop: string;
  type = 'radio';
  options: any[];
  /* istanbul ignore next */
  constructor(options = {}) {
    Object.assign(this, options);
  }
}

export const checkboxMatrixConfiguration = {
  prop: 'paperless_settings',
  type: 'checkboxMatrix',
  rowIdProp: 'id',
  columnIdProp: 'id',
  boldTitles: true,
  errorMessage: 'Uh oh...',
  radioConfig: {
    label: 'Generic (Radio)',
    prop: 'paperless',
    type: 'radio',
    value: true,
    options: [
      {
        value: true,
        label:
          'I consent to electronically receive alerts, reminders and notifications from Brand Health.',
      },
      {
        value: false,
        label:
          'I do not consent to electronically receive alerts, reminders and notifications from Brand Health.',
      },
    ],
  },
  title: 'Matrix Title',
  rows: 'preference_types',
  columns: 'preference_options',
};

export const staticMatrixConfiguration = {
  prop: 'paperless_settings',
  type: 'checkboxMatrix',
  rowIdProp: 'id',
  columnIdProp: 'id',
  boldTitles: true,
  errorMessage: 'Uh oh...',
  readOnly: {},
  title: 'Matrix Title',
  rows: 'preference_types',
  columns: 'preference_options',
  showGrid: 'paperless',
};

export const preferences = {
  id: 3,
  preference_group: 'CommunicationPreferences',
  paperless: true,
  preference_types: preferencesTypes,
  display_text: 'Communication Preferences',
  preference_options: [
    {
      detail_text: 'Email',
      id: 1,
      short_name: 'Email',
      priority_number: 1,
    },
    {
      detail_text: 'Mail',
      id: 2,
      short_name: 'Mail',
      priority_number: 2,
    },
    {
      detail_text: 'Text',
      id: 3,
      short_name: 'Text',
      priority_number: 3,
    },
  ],
};
